// Dynamic import for Module Federation bootstrap
import('./bootstrap');
